import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    iconSection: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(3)
    },
    icon: {
        fontSize: 150
    },
    textSection: {
        width: "75%",
        marginBottom: theme.spacing(3)
    },
    textHighlight: {
        fontSize: 24,
        fontWeight: "bold"
    },
    text: {
        fontSize: 20
    },
    form: {
        width: "75%",
        height: "190px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
    },
    formComponent: {
        width: "100%"
    },
    buttonContainer: {},
    button: {
        width: "100%"
    },
    footer: {
        marginTop: "auto",
        marginBottom: theme.spacing(2),
        width: "75%"
    },
}));

export default useStyles;